module.exports = __webpack_public_path__ + "static/img/icon_dakuan.364315a1.png";